import useConfigurationQuery from "hooks/queries/useConfigurationQuery";
import React from "react";
import { Helmet } from "react-helmet";

interface DocumentTitleProps {
  title?: string;
}

const DocumentTitle: React.FC<DocumentTitleProps> = ({ title }) => {
  const configQuery = useConfigurationQuery();

  return (
    <Helmet>
      <title>
        {title
          ? `${title} - ${configQuery.data?.applicationName}`
          : configQuery.data?.applicationName}
      </title>
      <meta
        name="description"
        content={configQuery.data?.applicationName ?? ""}
      />
    </Helmet>
  );
};

export default DocumentTitle;
